import clsx from "clsx";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react"
import InputMask from '../../libs/reactInputMask';
const estilosInput = require('../../estilos/inputs.module.scss').default

export type InputMascaraDinamicaProps = {
    valor: string
    onValorModificado: (valor:string) => void
    mascaras:string[]
    emitirComMascara?: boolean
    name?: string
    id?: string
    className?: string
    placeholder?:string
    disabled?:boolean
    selecionarTudo?:boolean
    habilitaEventoChange?:boolean
    onKeyPress?: (event: React.KeyboardEvent) => any
    autoFocus?: boolean
    teclaDeAtalho?: string
    type?: string
    style?: React.CSSProperties
}

const FORMAT_CHARS = {
    '9': '[0-9]',
    'S': '[0-9A-Za-z]'
}

export const InputMascaraDinamica = (props:InputMascaraDinamicaProps) => {
    const [valor,setValor] = useState(props.valor ?? "")

    const [dirty,setDirty] = useState(false)

    const [mascara, setMascara] = useState(props.mascaras[0])

    const mascarasOrdenadas = props.mascaras.sort((m1, m2) => m1.length - m2.length)

    const mascaraComportaValor = (m: string, valor_: string) => {
        const cabe = globalMU.removerMascara(m, valor_, true)?.length <= globalMU.mascaraSemCaracteresFormatacao(m).length
        const valorTemLetra = /[a-zA-Z]/.test(valor_ ?? '')
        return cabe && (!valorTemLetra || m.includes('S'))
    }

    const resolverMascara = (valor_:string) => {
        let parar = false
        mascarasOrdenadas.map(m => {
            if (mascaraComportaValor(m, valor_) && !parar)
            {
                setMascara(m)
                parar = true
            }
        })
    }

    const algumaMascaraValida = (valor_: string) => {
        return R.reverse(mascarasOrdenadas).some(m => mascaraComportaValor(m, valor_))
    }

    useEffect(() => {
        setValor(props.valor ?? "")
        resolverMascara(props.valor)
    }, [props.valor])

    const posicaoAposUltimoCaracterPreenchido = (m: string, quantidadePreenchida: number) => {
        let preenchidos = 0
        for (let i = 0; i < m.length; i++) {
            if (m[i] == 'S' || m[i] == '9') {
                preenchidos++
                if (preenchidos == quantidadePreenchida) return i + 1
            }
        }
        return m.length
    }

    const trocarParaMascaraAlfaAoDigitarLetra = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const ehLetra = /^[a-zA-Z]$/.test(e.key) && !e.ctrlKey && !e.altKey && !e.metaKey
        if (ehLetra && !mascara.includes('S')) {
            const mascaraAlfa = mascarasOrdenadas.find(m => m.includes('S'))
            if (mascaraAlfa) {
                e.preventDefault()
                const input = e.currentTarget
                const valorAtual = input.value ?? ''
                const cruAntesDaSelecao = valorAtual.substring(0, input.selectionStart ?? valorAtual.length).replace(/[^0-9A-Za-z]/g, '')
                const cruDepoisDaSelecao = valorAtual.substring(input.selectionEnd ?? valorAtual.length).replace(/[^0-9A-Za-z]/g, '')
                const novoValor = (cruAntesDaSelecao + e.key + cruDepoisDaSelecao).toUpperCase()
                setMascara(mascaraAlfa)
                setValor(novoValor)
                const posicaoCursor = posicaoAposUltimoCaracterPreenchido(mascaraAlfa, cruAntesDaSelecao.length + 1)
                setTimeout(() => input.setSelectionRange(posicaoCursor, posicaoCursor))
            }
        }
    }

    return <InputMask
        disabled={props.disabled}
        mask={mascara}
        formatChars={FORMAT_CHARS}
        value={valor ?? ""}
        onChange={e => {
            setValor(e.target.value)
            if(props.habilitaEventoChange && algumaMascaraValida(e.target.value)) {
                props.onValorModificado(props.emitirComMascara === undefined || props.emitirComMascara === true ? e.target.value : globalMU.removerMascara(mascara, e.target.value, true))
            }
            setDirty(true)
        }}
        autoComplete="off"
        aria-autocomplete="none"
        onBlur={e => {
            setValor(e.target.value)

            if (dirty) {
                props.onValorModificado(globalMU.valorComMascaraEhValido(mascara, e.target.value) ? 
                    (props.emitirComMascara === undefined || props.emitirComMascara === true ? e.target.value : globalMU.removerMascara(mascara, e.target.value, true)) : 
                    null)
            }

            setDirty(false)
        }}
        beforeMaskedValueChange={(newState, oldState, userInput) => {
            if (userInput) userInput = userInput.toUpperCase()
            if (newState.value) newState.value = newState.value.toUpperCase() 

            /* Quando usuario digita um caracter no final e valor está cheio tentar pegar a próxima mascara maior se existir */
            if (userInput?.length == 1 && mascara.length == newState.value.length && oldState.selection?.start == oldState.selection?.end && oldState.selection?.end == mascara.length && mascarasOrdenadas.length > (mascarasOrdenadas.indexOf(mascara)+1)) {
                setMascara(mascarasOrdenadas[mascarasOrdenadas.indexOf(mascara)+1])
                return { 
                    value: newState.value + userInput,
                    selection: { start: newState.selection?.start+1, end: newState.selection?.end +1 }
                }
            }
            /* Quando usuario cola os numeros, vai substituir o que tem dentro do campo */
            if (userInput?.length > 1 && algumaMascaraValida(userInput))
            {
                resolverMascara(userInput)
                return { 
                    value: userInput,
                    selection: { start: 255, end: 255 }
                }
            } 


            !userInput && resolverMascara(globalMU.removerMascara(mascara,newState.value,true))
            return {...newState }
        }}
        onFocus={(e) => props.selecionarTudo && e.target.select()}
        >
        {() => 
            <input 
                id={props.id} 
                key={props.id}
                autoFocus={props.autoFocus} 
                accessKey={props.teclaDeAtalho} 
                name={props.name} 
				type={props.type}
                disabled={props.disabled} 
                className={clsx(props.className, estilosInput.inputPadrao)} 
                placeholder={props.placeholder}
                onKeyDown={trocarParaMascaraAlfaAoDigitarLetra}
                onKeyPress={props?.onKeyPress}
                style={props.style}
        />}
    </InputMask>
}